const NotFound = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <h3 className="text-2xl font-bold">Nothing here. Just go back. 🙊</h3>
    </div>
  );
};

export default NotFound;
